import { render, staticRenderFns } from "./CardUsage.vue?vue&type=template&id=36a113d0&scoped=true"
import script from "./CardUsage.vue?vue&type=script&lang=js"
export * from "./CardUsage.vue?vue&type=script&lang=js"
import style0 from "./CardUsage.vue?vue&type=style&index=0&id=36a113d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a113d0",
  null
  
)

export default component.exports